export const function_mixins = {
  data() {
    return {}
  },

  methods: {
    m__sort_time_string_ranges(times) {
      try {
        return this.clone(times).sort((a, b) => {
          const get_time = (range) => range.split(' - ')[0]
          return get_time(a).localeCompare(get_time(b))
        })
      } catch (e) {
        console.error(e)
        return times
      }
    },

    m__sort_time_object_ranges(times) {
      if (!times) return []

      try {
        return this.clone(times).sort((a, b) => {
          const get_time = (range) => range.split(':')[0]
          return get_time(a.start_time).localeCompare(get_time(b.start_time))
        })
      } catch (e) {
        console.error(e)
        return times
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/function.js